import { CACHE_TIME, STALE_TIME } from '@/constants';
import { trpc } from '@/data-loaders';

export const useUnitWorkloadList = () => {
  return trpc.unit.getUnitWorkloadList.useQuery(
    { a: null },
    {
      retry: false,
      cacheTime: CACHE_TIME,
      staleTime: STALE_TIME,
      enabled: true,
    },
  );
};
